/**
 * <s-quantity-tiers> — Buy 1 / Buy 2 / Buy 3 bundle boxes on the product page.
 * Choosing a box writes its quantity into the product form's input[name="quantity"],
 * so Add to cart and Buy now submit that many units of the selected variant.
 * The savings themselves come from the store's automatic discounts at checkout.
 *
 * Markup: input[type="radio"][data-tier-quantity] for each box, inside the product form.
 */
class QuantityTiers extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    this.addEventListener('change', (event) => {
      const radio = event.target;
      if (!(radio instanceof HTMLInputElement) || !radio.dataset.tierQuantity) return;
      const quantityInput = this.#quantityInput();
      if (!quantityInput) return;
      quantityInput.value = radio.dataset.tierQuantity;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }, opts);

    // Keep the highlighted box in step with the quantity (also after a variant change).
    this.closest('form')?.addEventListener('change', (event) => {
      if (event.target === this.#quantityInput()) this.#syncFromQuantity();
    }, opts);

    this.#syncFromQuantity();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #quantityInput() {
    return this.closest('form')?.querySelector('input[name="quantity"]') ?? null;
  }

  #syncFromQuantity() {
    const value = this.#quantityInput()?.value;
    const match = this.querySelector(`input[data-tier-quantity="${CSS.escape(String(value))}"]`);
    if (match) match.checked = true;
  }
}

if (!customElements.get('s-quantity-tiers')) customElements.define('s-quantity-tiers', QuantityTiers);
